import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Reset-22",
  "use": "icon-Reset-22-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Reset-22\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.962 10.069a4.537 4.537 0 0 1 7.992-4.295l-1.187.33a.267.267 0 0 0-.088.471l2.464 1.845a.2.2 0 0 0 .306-.085l1.155-2.854a.267.267 0 0 0-.319-.357l-1.017.284-.044-.085a5.87 5.87 0 1 0-2.547 7.902.667.667 0 0 0-.608-1.187 4.537 4.537 0 0 1-6.107-1.969Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol